export default "__VITE_ASSET__CygEeL$n__"